__turbopack_context__.v({
  "BlueBackground": "Hero-module-sass-module__fRO3dG__BlueBackground",
  "Cont": "Hero-module-sass-module__fRO3dG__Cont",
  "Content": "Hero-module-sass-module__fRO3dG__Content",
  "Copy": "Hero-module-sass-module__fRO3dG__Copy",
  "Hero": "Hero-module-sass-module__fRO3dG__Hero",
  "Image": "Hero-module-sass-module__fRO3dG__Image",
  "Link": "Hero-module-sass-module__fRO3dG__Link",
  "Main": "Hero-module-sass-module__fRO3dG__Main",
});
